import image1 from '../../images/Funcions1_1.webp'
import image2 from '../../images/Funcions1_2.webp'
import image3 from '../../images/Funcions1_3.webp'

import styles from './Digitalitza.module.css'

const Digitalitza = () => {

    return (
        <div className={styles.container}>
            <section className={styles.heroImageContainer}>
                <img src={image1} alt="Transtorma digitalment els seguiments" className={styles.heroImage}/>
                <h1 className={styles.titleImage}>Sense paper, un format, una plataforma</h1>
                <h2 className={styles.titleImage2}><a href="mailto:codelabosona@gmail.com" className={styles.emailLink}><span>Informa't com</span><i className="fa-solid fa-arrow-right"></i></a></h2>
            </section>
            <section className={`${styles.section} ${styles.sectionFirst}`}>
                <div className={styles.section2}>
                    <img src={image2} alt="Transtorma digitalment els seguiments" className={styles.images}/>
                </div>
                <div className={styles.section1}>
                    <ul>
                        <li>Digitalitza el Seguiment de Persones</li>
                        <li>Socialin permet registrar i accedir a tota la informació de manera instantània, seguint un enfocament centrat en la persona.</li>
                        <li>Optimitza els Recursos</li>
                        <li>Centralitza la gestió en una plataforma única, reduint el temps dedicat a tasques administratives i enfocant-te en el què realment importa: les persones que atens.</li>
                        <li>Impulsa la Transformació Digital</li>
                        <li>Ajudem la teva organització a adaptar-se a les necessitats del futur, alineant-la amb les pràctiques digitals més innovadores.</li>
                    </ul>
                </div>
            </section>
            <section className={`${styles.section} ${styles.sectionSecond}`}>
                <div className={styles.section1}>
                    <h2>Converteix la gestió social en un procés més eficient i col·laboratiu i, sobretot, menys administratiu. Porta la teva organització al següent nivell.</h2> 
                    <ul>
                        <li>- Seguiments en un sol format.</li>
                        <li>- Seguiments per competències.</li>
                        <li>- No Excels.</li>
                        <li>- Accessibles en temps real des de qualsevol lloc.</li>
                        <li>- Compliment normatiu i seguretat de la informació.</li>
                    </ul>
                    <a href="mailto:codelabosona@gmail.com" className={styles.emailLink}><span>Informa't com</span><i className="fa-solid fa-arrow-right"></i></a>
                </div>
                <div className={styles.section2}>
                    <img src={image3} alt="Transtorma digitalment els seguiments" className={styles.images}/>
                </div>       
            </section>
        </div>
    )
}

export default Digitalitza